// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/css/swiper.min.css'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

Vue.use(Viewer) //图片放大预览

Vue.config.productionTip = false

// 这里是插件的默认设置
Viewer.setDefaults({
  zIndexInline: 9999,
  navbar: false
})

/* URL */
Vue.prototype.GetServerUrl = function (v) {
  // return 'http://120.79.56.121:9091/v'+v+'/' // 测试环境
  return 'https://api.cnmgs.cn/v' + v + '/' // 生产环境
}

/* URL */
Vue.prototype.GetCxServerUrl = function (v=1) {
  // return 'http://120.79.56.121:9091/v'+v+'/' // 测试环境
  return 'https://sale.cnmgs.cn/v' + v + '/' // 生产环境
}

/* URL */
Vue.prototype.GetVideoUrl = function (v) {
  return 'http://file.cnmgs.cn'
}

/* 获取URL参数 */
Vue.prototype.GetParams = function () {
  let urlStr = location.search.substring(1).replace(/&/g, '?');
  urlStr = urlStr.split('?');
  let params = {};
  for (let i in urlStr) {
    let arr = urlStr[i].split('=');
    params[arr[0]] = arr[1];
  }
  return params;
}

/* 获取URL参数 */
Vue.prototype.GetParamsNew = function () {
  let params = {};
  let urlStr = document.location.toString();

  //判断是否有参数
  if (urlStr.indexOf("?") != -1) {
    const firstIndex = urlStr.indexOf("&") + 1;
    urlStr = urlStr.substring(firstIndex, urlStr.length).split('&');
    for (let i in urlStr) {
      let arr = urlStr[i].split('=');
      params[arr[0]] = arr[1];
    }
  }

  return params;
}

/* URL */
Vue.prototype.GetCode = function (v) {
  let url = document.location.toString();

  //判断是否有参数
  if (url.indexOf("?") != -1) {
    let firstIndex = url.indexOf("?") + 1;
    let lastIndex = url.length;
    if (url.indexOf("#") != -1) {  //正式环境
      lastIndex = url.indexOf("#");
    }
    if (url.indexOf(",") != -1) {  //带防伪码
      lastIndex = url.indexOf(",");
    }
    if (url.indexOf("=") != -1) {  //防止微信分享附加内容
      lastIndex = url.indexOf("=");
    }
    if (url.indexOf("&") != -1) {  //带其他参数
      lastIndex = url.indexOf("&");
    }

    let code = url.substring(firstIndex, lastIndex);
    return code;
  } else {
    return false;
  }
}

/* 错误提示 */
Vue.prototype.ErrorHint = function (error) {
  let msg;
  if (error.response) {
    if (error.response.data.message) {
      msg = error.response.data.message;
    } else {
      msg = error.response.statusText;
    }
  } else {
    msg = "请检查网络连接！";
  }
  return msg;
}

/* 自适应像素 */
Vue.prototype.AdaptiveSize = function (error) {
  let w = document.documentElement.getBoundingClientRect().width / 16
  document.documentElement.style.fontSize = w + "px"
}

//rem单位自适应
Vue.prototype.AdaptiveSizeNew = function (w=750) {
  const customWidth = w; //设计图大小
  const winWidth = document.body.offsetWidth; //设备宽度
  const initSize = winWidth / customWidth; //计算比例
  const html = document.getElementsByTagName('html')[0]; //获取html顶部对象
  html.style.fontSize = initSize + 'px'; //设置初始大小
}

/* 防伪查询 */
Vue.prototype.CodeVerify = function (axios, back) {
  var self = this;
  axios.get(this.GetServerUrl(1) + "queryVerify/" + this.code + "/" + this.verify)
    .then(function (res) {
      back(res);
    }).catch(function (error) {
      console.log(error)
      self.verify = null;
      self.AlertMsg.state = true;
      self.AlertMsg.name = self.datas.business.name;
      self.AlertMsg.msg = self.ErrorHint(error);
    })
}

//验证手机号码是否正确
Vue.prototype.qIsMobile = function (mobile) {
  if (/^1(3[4-9]|47|5[0-2]|5[7-9]|82|83|87|88|78|98)\d{8}$/.test(mobile)) { //中国移动
    return true;
  } else if (/^1(3[0-2]|45|55|56|85|86|76|75|71|66)\d{8}$/.test(mobile)) { //中国联通
    return true;
  } else if (/^1(33|53|80|81|89|56|77|73|99|49|91)\d{8}$/.test(mobile)) { //中国电信
    return true;
  } else if (/^8(52|53|86)\d{8}$/.test(mobile)) { //中国电信
    return true;
  }

  return false;
}

//正则匹配验证码
Vue.prototype.qIsAuthCode = function (str) {
  var re = /^\d{6,10}$/;
  return re.test(str);
}

//验证身份证号码
Vue.prototype.qIIdcard = function (idcard) {
  if (idcard == '' || idcard == null || idcard == undefined) {
    return false;
  }
  var re = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  return re.test(idcard);
}

//验证身份证号码
Vue.prototype.selfAdaption = function (idcard) {
  const customWidth = 750; //设计图宽度
  const winWidth = document.body.offsetWidth;
  const initSize = winWidth / customWidth;
  const html = document.getElementsByTagName('html')[0];
  html.style.fontSize = initSize + 'px';
}


Vue.prototype.skipLink = function (url){
    // 获取用户代理信息(不考虑代理信息被伪装的情况)
    var userAgent = (navigator.userAgent || navigator.vendor || window.opera) || 'Unknown';
    // 检查是否是iPhone或iPad
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        // 如果是移动设备，则重定向页面
        window.location.href = url;
    } else {
        // 否则，在新窗口打开链接
        window.open(url);
    }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js